import React from 'react'
import TextInput from '../../../components/TextField'
import SelectInput from '../../../components/SelectInput'
import DateInput from '../../../components/DateInput'
import { EmployeeType } from '../../../constants'
import { Switch } from '@mui/material'


const JobDetails = ({ data, methods }) => {
    const { error, teamMemberInputs, allRolesList, allShiftList, reportManagerData,agentId } = data
    const { handleInputChange, handleBlur, setTeamMemberInputs, handleDateChange, setError, } = methods

    // console.log(allShiftList,'allShiftList')
    const disabled=agentId==='add'?false:true
    // console.log(disabled,'disabled')
    return (
        <>
            <div className="row mt-4">
                <div className="col-lg-4 mt-4">
                    <TextInput
                        Lable="Designation"
                        Name="designation"
                        variant="outlined"
                        ClassName="form-field-design"
                        HandleInputChange={handleInputChange}
                        // onBlur={handleBlur}
                        Value={teamMemberInputs?.designation}
                        width={100}
                        // Require={true}
                        Error={error?.designation}
                        Disable={disabled}
                    />
                </div>
                <div className="col-lg-4 mt-4">
                    <DateInput
                        className="w-100 form-field-design"
                        isRequired={true}
                        Label={'Date of Joining'}
                        handleDateChange={(date) => { handleDateChange(date, 'dateOfJoining'); setError((pre) => ({ ...pre, dateOfJoining: '' })) }}
                        SelectedDate={teamMemberInputs?.dateOfJoining}
                        disabled={disabled}
                    />
                    {error?.dateOfJoining && <span className='text-danger' style={{ fontSize: "11px" }}>{error?.dateOfJoining}</span>}
                </div>
                <div className="col-lg-4 mt-4">
                    <SelectInput
                        Lable={'Employee Type'}
                        width={'310px'}
                        Options={EmployeeType}
                        keyName={'title'}
                        className="form-field-design"
                        Name="empType"
                        SelectValue={teamMemberInputs?.empType}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.empType}
                        variant={'outlined'}
                        isRequired={true}
                        disabled={disabled}
                    />
                </div>
                <div className="col-lg-4 mt-4">
                    <SelectInput
                        Lable={'Shift'}
                        width={'310px'}
                        Options={allShiftList}
                        keyName={'name'}
                        className="form-field-design"
                        Name="shift"
                        SelectValue={teamMemberInputs?.shift}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.shift}
                        variant={'outlined'}
                        isRequired={true}
                        disabled={disabled}
                    />
                </div>

                <div className="col-lg-4 mt-4">
                    <SelectInput
                        Lable={'Roles'}
                        Options={allRolesList}
                        keyName={'roleTitle'}
                        className="form-field-design"
                        Name="role_id"
                        SelectValue={teamMemberInputs?.role_id}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.role_id}
                        variant={'outlined'}
                        isRequired={true}
                        disabled={disabled}
                    />
                </div>
                <div className="col-lg-4 mt-4">
                    <SelectInput
                        Lable={'Reporting Manager'}
                        width={'310px'}
                        Options={reportManagerData}
                        keyName={'firstName'}
                        className="form-field-design"
                        Name="reportingManager"
                        SelectValue={teamMemberInputs?.reportingManager}
                        HandleChange={handleInputChange}
                        onBlur={handleBlur}
                        Error={error?.reportingManager}
                        variant={'outlined'}
                        disabled={disabled}
                    />
                </div>
                <div className="col-lg-4 mt-4">
                    <TextInput
                        Lable="Probation Days"
                        Name="probationDays"
                        variant="outlined"
                        ClassName="form-field-design"
                        HandleInputChange={handleInputChange}
                        onBlur={handleBlur}
                        Value={teamMemberInputs?.probationDays}
                        width={100}
                        Require={true}
                        type={'number'}
                        Error={error?.probationDays}
                        Disable={disabled}
                    />
                </div>
                <div className="col-lg-4 mt-5">
                    <label htmlFor="" style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.6)' }}>Earn leave caluculate</label>
                    <Switch checked={teamMemberInputs?.elCalculate} disabled={disabled} onChange={(e) => setTeamMemberInputs((pre) => ({ ...pre, elCalculate: e.target.checked }))} />
                </div>
            </div>

        </>
    )
}

export default JobDetails
